import { render } from "./CustomTable.vue?vue&type=template&id=ecb5ae10&scoped=true&ts=true"
import script from "./CustomTable.vue?vue&type=script&lang=ts"
export * from "./CustomTable.vue?vue&type=script&lang=ts"

import "./CustomTable.vue?vue&type=style&index=0&id=ecb5ae10&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ecb5ae10"]])

export default __exports__